import { Component, OnInit, Input, computed, signal, OnChanges } from '@angular/core';
import { FlowObjectInstance } from '../../../models/flow-object.model';
import { EDocsService } from '../../../services/edocs.service';
import { Enums } from '../../../shared/enums';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { PdfPreviewDialogComponent } from '../../pdf-preview-dialog/pdf-preview-dialog.component';
import { Utils } from '../../../shared/utils';
import { FlowInstance } from '../../../models/flow.model';
import { ConfigSchema } from '../../../models/config-schema.model';
import { InputDataTaskForward, OutputDataTaskForward } from '../../../models/input-output-data.model';
import { IMPORTS } from './_imports';

@Component({
    selector: 'fob-forward',
    templateUrl: './fob-forward.component.html',
    styleUrl: './fob-forward.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class FlowObjectForwardComponent implements OnInit, OnChanges {
    // #region [props]
    outputData: OutputDataTaskForward;
    // #endregion

    // #region [signals]
    $model = signal(null as FlowObjectInstance);
    $flowInstance = signal(null as FlowInstance);
    $configSchema = signal(null as ConfigSchema);
    $inputData = signal(null as InputDataTaskForward);
    $protocolo = signal('');
    $previousDocuments = signal([] as any[]);
    // #endregion

    // #region [computeds]
    $currentUser = computed(() => this.authService.$user());
    $dateString = computed(() => this.$model() == null ? '' : new Date(this.$model().updateDate).toLocaleString());
    // #endregion

    // #region [Input/Output]
    @Input() _model: FlowObjectInstance;
    @Input() _flowInstance: FlowInstance;
    // #endregion

    constructor(
        private dialog: MatDialog,
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private authService: AuthService,
        private eDocsService: EDocsService
    ) { }

    async ngOnInit() {
        this.$configSchema.set(JSON.parse(this.$model().flowObjectDefinition.configSchema) as ConfigSchema);
        this.$inputData.set(JSON.parse(this.$model().inputData) as InputDataTaskForward);
        this.outputData = JSON.parse(this.$model().outputData) as OutputDataTaskForward;

        const response_Encaminhamento = await this.eDocsService.getEncaminhamento(this.outputData.eDocsData.forwardingId);

        if (!response_Encaminhamento.isSuccess) {
            this.toastr.error(response_Encaminhamento.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
            return;
        }

        const encaminhamento = response_Encaminhamento.data;
        this.$protocolo.set(encaminhamento.protocolo);

        // #region [documentos capturados anteriormente à Tarefa corrente]
        for (let item of encaminhamento.documentosEncaminhamento.filter(x => !x.controle)) {
            if (Utils.isNotNullOrEmpty(this.outputData) && this.outputData.eDocsData.forwardingId == item.documento.encaminhamentoId) {
                break;
            }

            if (!this.$previousDocuments().some(x => x.registro == item.documento.registro)) {
                Utils.updSignal(this.$previousDocuments, x => {
                    x.push({
                        id: item.documento.id,
                        registro: item.documento.registro,
                        filename: `${item.documento.nome}.${item.documento.extensao}`
                    });
                    return x;
                });
            }
        }
        // #endregion

        // #region [documentos capturados na Tarefa corrente]
        if (Utils.isNotNullOrEmpty(this.outputData)) {
            let filteredDocs = encaminhamento.documentosEncaminhamento.filter(x =>
                x.documento.encaminhamentoId == this.outputData.eDocsData.forwardingId
                && !x.controle
            );

            for (let item of filteredDocs) {
                if (!this.$previousDocuments().some(x => x.registro == item.documento.registro)) {
                    Utils.updSignal(this.$previousDocuments, x => {
                        x.push({
                            id: item.documento.id,
                            registro: item.documento.registro,
                            filename: `${item.documento.nome}.${item.documento.extensao}`
                        });
                        return x;
                    });
                }
            }
        }
        // #endregion
    }

    ngOnChanges() {
        this.$model.set(this._model);
        this.$flowInstance.set(this._flowInstance);
    }

    async openDocumentModal(id: string) {
        this.spinner.show('flowInstance');

        const response = await this.eDocsService.getDocumentoDownloadUrl(id);

        this.spinner.hide('flowInstance');

        if (!response.isSuccess) {
            this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
            return;
        }

        setTimeout(() => {
            this.dialog.open(PdfPreviewDialogComponent, {
                data: {
                    content: response.data
                }
            });
        }, 200);
    }

    // #region [===== private methods =====]
    // #endregion
}
